var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head",attrs:{"id":"v2-course-pay-header"}},[_c('h1',[_c('sup',[_vm._v("¥")]),_c('span',[_vm._v(_vm._s(_vm.price))])]),_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }